// WHERE I HAVE TO BE TODAY — the day's meetings, in time order.
//
// IN THE ORDER THE SERVER SENT THEM. `/meetings?from=T&to=T` orders by date, then start
// time, then id, and for a single day that IS time order. Re-sorting here would be the
// browser holding a second opinion about something it was already told.
//
// IT BORROWS THE CALENDAR'S RULES RATHER THAN RESTATING THEM: what a meeting is called,
// what colour it is drawn in, and whether it involves a given partner are all decisions
// the calendar already owns, and a second copy is how the same meeting comes to look like
// two different things on two screens. They are imported read-only — nothing in
// pages/Calendar is edited, and moving those helpers up into components/ would have meant
// touching every calendar file that imports them.
//
// A CANCELLED MEETING STAYS ON THE LIST, struck through. The day held it and it was called
// off; dropping the row would leave an hour that reads as free with no explanation of why
// it was ever otherwise.
import { Link } from 'react-router-dom';
import he from '../../i18n/he';
import { dotStyle } from '../Calendar/meetingColors';
import { isCancelled, isHeld, isInternal } from '../Calendar/meetingKind';
import { meetingLabel } from '../Calendar/MeetingChip';

// What became of it. A meeting is neither late nor on time — it is AT a time — so its
// badge reports its fate rather than its punctuality, and a plain scheduled meeting gets
// no badge at all: on a day page, "still going to happen" is the default and marking it
// would make the two that matter harder to see.
function MeetingState({ meeting }) {
  if (isCancelled(meeting)) return <span className="badge gray">{he.myDay.meetingCancelled}</span>;
  if (isHeld(meeting)) return <span className="badge green">{he.myDay.meetingHeld}</span>;
  return null;
}

export default function DayMeetings({ meetings, partners }) {
  return (
    <div className="day-rows">
      {meetings.map((m) => (
        // Plain /calendar: the calendar holds its date and view in local state and has no
        // per-meeting URL to link to. Better an honest link to the screen it lives on than
        // a deep link invented here.
        <Link key={m.id} to="/calendar" className="day-row day-meeting">
          <span className="day-time">
            <span className="day-time-start">{m.start_time}</span>
            <span className="day-time-end">{m.end_time}</span>
          </span>
          <span className="day-meeting-body">
            <span className="day-row-head">
              <span className="meeting-dot" style={dotStyle(m, partners)} />
              <span className={`day-row-name${isCancelled(m) ? ' struck' : ''}`}>
                {meetingLabel(m)}
              </span>
              {/* Only when it has a title of its own. An untitled internal meeting is
                  already CALLED "פגישה פנימית" by meetingLabel, and saying it twice on
                  one line is how a marker stops being read. */}
              {isInternal(m) && m.title && (
                <span className="muted small-note">· {he.myDay.meetingInternal}</span>
              )}
              <MeetingState meeting={m} />
            </span>
            <span className="day-row-foot">
              {/* WHOSE DIARY THIS IS, which is the question the filter above asks. An
                  internal meeting names both partners — it occupies both diaries and
                  belongs to neither one of them alone. */}
              <span className="muted">
                {[
                  isInternal(m) ? `${m.owner_name} · ${m.with_name}` : m.owner_name,
                  m.job_title,
                ].filter(Boolean).join(' · ')}
              </span>
              <span className="day-row-go">{he.myDay.goCalendar}</span>
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}
